// Manage flow of all booker authorization screens here
import React, { Component } from 'react';
import PropTypes from 'prop-types';

import AccountInfo from './AccountInfo';
import SendEmail from './SendEmail';
import Authorize from './Authorize';
import SetupSuccess from './SetupSuccess';

export default class BookerSetup extends Component {
  constructor() {
    super();

    this.state = {
      isAccountInfoSaved: false,
      isEmailSent: false,
      isSetupComplete: false
    };

    this.handleBackAction = this.handleBackAction.bind(this);
  }

  componentWillReceiveProps(nextProps) {
    const { softwares: prevSoftwares } = this.props;
    const { softwares: newSoftwares } = nextProps;
    const newState = {};

    if (
      prevSoftwares.isSavingBookerAccountInfo &&
      !newSoftwares.isSavingBookerAccountInfo &&
      newSoftwares.isBookerAccountInfoSaveSuccess
    ) {
      newState.isAccountInfoSaved = true;
    }

    if (newSoftwares.isBookerEmailSendSuccess) {
      newState.isEmailSent = true;
    }

    if (prevSoftwares.isSavingStaffCredentials && !newSoftwares.isSavingStaffCredentials) {
      newState.isSetupComplete = true;
    }

    if (Object.keys(newState).length) {
      this.setState(newState);
    }
  }

  handleBackAction(screen) {
    if (screen === 'authorize') {
      this.setState({
        isEmailSent: false,
      });
    } else if (screen === 'email') {
      this.props.onBookerEmailSendReset();
      this.setState({
        isAccountInfoSaved: false,
        isEmailSent: false,
      });
    }
  }

  render() {
    const { history } = this.props;
    const { isAccountInfoSaved, isEmailSent, isSetupComplete,bookerAccountInfo } = this.state;

    if (isSetupComplete) {
      // Show setup success screen
      return (
        <SetupSuccess
          onDone={() => {
            // Get Bookings Software Info
            this.props.getBookingSoftware();

            // Redirect to summary screen
            history.push('/app/setup');
          }}
          {...this.props}
        />
      );
    }

    // if (isEmailSent) {
    //   // Show Staff Add screen
    //   return (
    //     <Authorize
    //       onBack={() => {
    //         this.handleBackAction('authorize');
    //       }}
    //       {...this.props}
    //     />
    //   );
    // }

    if (isAccountInfoSaved) {
      // Show Email Compose screen
      return (
        <SendEmail
          onBack={() => {
            this.handleBackAction('email');
          }}
          {...this.props}
        />
      );
    }

    return <AccountInfo {...this.props} />;
  }
}

BookerSetup.propTypes = {
  getBookingSoftware: PropTypes.func.isRequired,
  softwares: PropTypes.shape().isRequired,
  onBookerEmailSendReset: PropTypes.func.isRequired,
  router: PropTypes.shape().isRequired,
};
